import React from 'react'
import { Link } from 'react-router-dom'

const SidebarInf03 = () => {
  return (
    <div className="flex-shrink-0 p-3  sidebar" style={{backgroundColor:'var(--color-bg)'}}>
    <div className='mafixedsidebar'>
    <p className="d-flex justify-center align-items-center pb-3 mb-3 border-bottom fs-5 fw-semibold" style={{justifyContent:"center"}}>E14/EE09/INF03</p>

    <ul className="list-unstyled ps-0">
      <li className="mb-1">
        <Link to="/egzaminy/inf03/sidebarhelp" className="btn btn-normal d-inline-flex align-items-center rounded border-0 collapsed"   aria-expanded="true">
          Strona Główna
        </Link>
        
      </li>
      <li className="mb-1">
        <button className="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#dashboard-collapse" aria-expanded="false">
          Rodzaje Zadań
        </button>
        <div className="collapse" id="dashboard-collapse">
          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
            <li><Link to="/egzaminy/inf03/bazadanychsql" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Baza danych - SQL</Link></li>
            <li><Link to="/egzaminy/inf03/skryptphp" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Skrypt PHP</Link></li>
            <li><Link to="/egzaminy/inf03/skryptjs" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Skrypt JS</Link></li>
            <li><Link to="/egzaminy/inf03/grafika" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Grafika</Link></li>
            
          </ul>
        </div>
      </li>
      <li class="mb-1">
        <button className="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#orders-collapse" aria-expanded="false">
          Wskazówki i pomoc
        </button>
        <div className="collapse" id="orders-collapse">
          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
            <li><Link to="/egzaminy/inf03/tworzenieimportowaniexampp" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Tworzenie i importowanie <br/>bazy danych</Link></li>
            <li><Link to="/egzaminy/inf03/laczenieizamykaniexampp" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Łączenie i zamykanie <br/> połączenia PHP</Link></li>
            <li><Link to="/egzaminy/inf03/crudphpxampp" className="link-body-emphasis d-inline-flex text-decoration-none rounded">CRUD XAMPP(SQL) + PHP</Link></li>
          </ul>
        </div>
      </li>
      <li class="mb-1">
        <button className="btn btn-toggle d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#pow-collapse" aria-expanded="false">
          Szybka Powtórka
        </button>
        <div className="collapse" id="pow-collapse">
          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
            <li><Link to="/egzaminy/inf03/teoria" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Teoria</Link></li>
            <li><Link to="/egzaminy/inf03/praktyka" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Praktyka</Link></li>
          </ul>
        </div>
      </li>
      <li className="border-top my-3"></li>
      <li className="mb-1">
        <button className="btn btn-toggle disabled d-inline-flex align-items-center rounded border-0 collapsed" data-bs-toggle="collapse" data-bs-target="#account-collapse" aria-expanded="false">
          Ustawienia (W Budowie)
        </button>
        <div className="collapse" id="account-collapse">
          <ul className="btn-toggle-nav list-unstyled fw-normal pb-1 small">
            <li><a href="#" className="link-body-emphasis d-inline-flex text-decoration-none rounded">New...</a></li>
            <li><a href="#" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Profile</a></li>
            <li><a href="#" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Ustawienia</a></li>
            <li><a href="#" className="link-body-emphasis d-inline-flex text-decoration-none rounded">Sign out</a></li>
          </ul>
        </div>
      </li>
    </ul>
    </div>
  </div>
  )
}

export default SidebarInf03